"use client";
import {
    Sheet, SheetContent, SheetTrigger
} from "@/components/ui/sheet";
import { createToken } from "@/src/action";
import { handleErrors, post } from "@/src/api/apiHandler";
import { showToast } from "@/src/components/toast/showToast";
import useLoginStore from "@/src/store/useLoginStore";
import useUserStore from "@/src/store/useUser";
import { ConvertLink } from "@/src/tools";
import {
    Fingerprint,
    LogOut, Menu, Newspaper,
    Send, Slack, User
} from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";

const secondaryLinks = [
    { href: "/brand?page=1", icon: <Slack size={20} />, label: "برندها" },
    { href: "/articles?page=1", icon: <Newspaper size={20} />, label: "مقالات" },
    { href: "/tracking", icon: <Send size={20} />, label: "پیگیری سفارش" }
];

export default function MenuHeader({ cat }: {cat: any}) {
    const { dataUser, deleteUser } = useUserStore();
    const { openLogin } = useLoginStore();
    const router = useRouter();

    const handleLogout = async () => {
        try {
            await post('/user-logout', {});
        } catch (err) {
            handleErrors(err);
        }
        await createToken('');
        deleteUser();
        router.push('/');
        showToast('با موفقیت خارج شدید', 'success');
    };

    return (
        <Sheet>
            <SheetTrigger asChild>
                <button aria-label="Open menu" className="rounded-full p-2 hover:bg-gray-100 dark:hover:bg-slate-700 transition">
                    <Menu size={26} className="text-gray-700 dark:text-gray-200" />
                </button>
            </SheetTrigger>

            <SheetContent side="right" className="p-0 bg-white dark:bg-slate-800 max-w-[330px]">
                <div className="flex flex-col h-full">

                    {/* Header */}
                    <div className="flex flex-col items-center border-b border-gray-100 dark:border-slate-700 pb-5 pt-6 px-6">
                        <Link href="/" className="mb-3">
                            <Image
                                src="/hiroonia.png"
                                alt="hiroonia logo"
                                width={60}
                                height={60}
                                className="rounded-lg shadow-sm object-contain"
                                priority
                            />
                        </Link>
                        {dataUser?.token ? (
                            <button onClick={() => router.push('/profile')}
                                className="flex items-center gap-2 text-gray-700 dark:text-gray-200 font-medium hover:text-primary transition">
                                <User size={20} />
                                <span>پروفایل من</span>
                            </button>
                        ) : (
                            <button onClick={() => openLogin()}
                                className="flex items-center gap-2 text-gray-500 dark:text-gray-400 font-medium hover:text-primary transition">
                                <Fingerprint size={20} />
                                <span>ورود / ثبت‌نام</span>
                            </button>
                        )}
                    </div>

                    {/* دسته‌بندی‌ها */}
                    <nav className="flex-1 overflow-y-auto custom-scrollbar py-3 px-1">
                        <div className="mb-3 px-3 text-xs text-gray-500 dark:text-gray-400">دسته‌بندی‌ها</div>
                        <ul className="space-y-1">
                            {cat?.data?.map((item: any) => (
                                <li key={item.cat_title}>
                                    <Link
                                        href={`/categories/${ConvertLink(item.cat_url)}`}
                                        className="flex items-center gap-1 px-4 py-1 rounded-md font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-slate-700 transition"
                                    >
                                        {/* اگر آیکون می‌خوای اینجا بگذار */}
                                        <span className="text-base">{item.cat_title}</span>
                                    </Link>
                                </li>
                            ))}
                        </ul>

                        <div className="mt-7 mb-2 px-3 text-xs text-gray-500 dark:text-gray-400">سایر بخش‌ها</div>
                        <ul className="space-y-1">
                            {secondaryLinks.map(item => (
                                <li key={item.label}>
                                    <Link
                                        href={item.href}
                                        className="flex items-center gap-2 px-4 py-2 rounded-md font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-slate-700 transition"
                                    >
                                        {item.icon}
                                        <span className="text-base">{item.label}</span>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    {/* Logout در انتهای منو (اگر لاگین است) */}
                    {dataUser?.token && (
                        <div className="p-5 border-t border-gray-100 dark:border-slate-700">
                            <button
                                onClick={handleLogout}
                                className="w-full flex items-center justify-center gap-2 px-4 py-2 rounded-md text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/40 transition font-medium"
                            >
                                <LogOut size={18} />
                                خروج
                            </button>
                        </div>
                    )}
                </div>
            </SheetContent>
        </Sheet>
    );
}
